import { frontendURL } from '../../../../helper/URLHelper';

const simplifiedReports = accountId => ({
  parentNav: 'simplified_reports',
  routes: [
    'simplified_account_overview_reports',
    'simplified_conversation_reports',
    'simplified_agent_reports',
    'simplified_csat_reports',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/simplified-reports/simplified-overview`),
      toStateName: 'simplified_account_overview_reports',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/simplified-reports/simplified-conversation`),
      toStateName: 'simplified_conversation_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/simplified-reports/simplified-agent`),
      toStateName: 'simplified_agent_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/simplified-reports/simplified-csat`),
      toStateName: 'simplified_csat_reports',
    },
  ],
});

export default simplifiedReports;
